import React from 'react';
import {
  Table as MuiTable,
  TableCell,
  // eslint-disable-next-line no-restricted-imports
  Typography,
  withStyles,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
} from '@material-ui/core';

export { TableCell, TableRow, TableBody, TableContainer, TableHead, TableFooter };

export const Table = withStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[400]}`,
    '& tr': {
      height: '50px',
      '& > td, & > th': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
}))(MuiTable);

export const HeaderCell = withStyles((theme) => ({
  head: {
    border: 0,
    fontWeight: theme.typography.fontWeightBold,
  },
}))(TableCell);

export const AlternatingTableRow = withStyles((theme) => ({
  root: {
    height: '50px',
    backgroundColor: theme.palette.grey[100],
    '&:nth-child(2n)': {
      backgroundColor: theme.palette.common.white,
    },
    '& > td': {
      borderBottom: 'none',
    },
  },
}))(TableRow);

export const BodyCell: React.FC<React.ComponentProps<typeof TableCell>> = ({
  children,
  ...rest
}) => (
  <TableCell {...rest}>
    <Typography variant='body2'>{children}</Typography>
  </TableCell>
);
